module.exports = function() {
  return new Worker(__webpack_public_path__ + "df05ec962a6c925a95ac.worker.js");
};